import { gql } from '@provision/graphql-client';
import { SIGNAL_INCIDENT_TIMELINE_FIELDS } from './signal-incident.fragments';

export const GET_CONVERSATION_SIGNAL_INCIDENTS_QUERY = gql`
  query GetConversationSignalIncidents($params: QueryParams)
  @entity(name: "SignalIncident") {
    getSignalIncident(queryParams: $params) {
      records {
        ...SignalIncidentTimelineFields
      }
    }
  }
  ${SIGNAL_INCIDENT_TIMELINE_FIELDS}
`;

export const RESOLVE_SIGNAL_INCIDENT_MUTATION = gql`
  mutation ResolveSignalIncident($input: ResolveSignalIncidentInput!) {
    resolveSignalIncident(input: $input) {
      signalIncident {
        ...SignalIncidentTimelineFields
      }
    }
  }
  ${SIGNAL_INCIDENT_TIMELINE_FIELDS}
`;
